/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import AssetIconService from '@/services/AssetIconService';

import {
  LayerGroup, LeafletEvent, Marker, GeoJSON, LatLng
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { toRaw } from 'vue';

export default class TrafficLayerService extends LayerService {
  onClick(e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void {
    const template: string = metaData.description;
    const lastUpdate = !!metaData.data && !!metaData.data.date_time
                       ? metaData.data.date_time as string
                       : this.noData;
    let modalIconUrl: string = AssetIconService.getSvgModalIcon('modal_traffic');

    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: undefined,
      lastUpdate: lastUpdate,
      icon: modalIconUrl,
      templateName: 'TemplateModalTrafficLine',
      hideModalBtn: true,
      metaData: metaData,
    };
    // store.commit('displayModal', modalData);
  };

  protected generatePolyLinesLayer = (polylines: IFeatureCollection): LayerGroup => {
    const layerGroup = new LayerGroup();

    const selectedTrafficLineCode: number | null = store.state.selectedTrafficLineCode;

    const { 
      values: trafficLegend, 
      no_data_color: noDataColor,
      default_color: defaultColor, 
      param: segmentParam,
    } = store.state.segmentsConfig;
    // Sort by value ascending
    const sortedTrafficLegend = Object.values(trafficLegend).sort((a, b) => a.value - b.value);

    polylines.features.map((feature): GeoJSON => {
      const [lat, lng] = this.findPolygonCenter(feature);
      const metaData = feature.properties as any;
      // any used because IFeature definition isn't exactly the same as leaflets
      // internal GeoJSON feature definition
      const polyline: GeoJSON = new GeoJSON(feature as any, {
        coordsToLatLng: this.coordsToLatLng,
      });

      const isActiveLine: boolean = selectedTrafficLineCode && selectedTrafficLineCode === metaData.code 
        ? true : false;

      let lineColor: string = defaultColor;

      if (metaData.last_status && metaData.last_status[segmentParam]) {
        const paramToCheck = metaData.last_status[segmentParam];
        // Find the first range where speed <= value
        const result = sortedTrafficLegend.find(condition => paramToCheck <= condition.value);
        if (result) {
          lineColor = result.color;
        } else {
          // If no range found, use the last color
          lineColor = sortedTrafficLegend[sortedTrafficLegend.length - 1].color;
        }
      } else {
        lineColor = noDataColor;
      }
      // Set polygon color
      polyline.setStyle({
        // color: lineColor,
        color: feature.properties.color,
        weight: 4,
        className: `polyline-path ${isActiveLine ? 'polyline-path--active' : ''}`,
      });

      // polyline.on('click', (e) => {
      //   this.onClick(e, metaData, new Marker(new LatLng(lat, lng)));
      //   // when modal is opened 
      //   polyline.setStyle({
      //     weight: 8,
      //   });
      // });

      layerGroup.addLayer(toRaw(polyline));
      return polyline;
    });

    return layerGroup;
  };

  redrawLayer = (): LayerGroup<any> => {
    const { traffic } = store.state;
    return this.generatePolyLinesLayer(traffic);
  };
}
